import { ScarabCommand } from './ScarabQueue';

export const pushScarabCommands = (...commands: ReadonlyArray<ScarabCommand>): void => {
  const scarabQueue: Array<ScarabCommand> = (globalThis.ScarabQueue ??= []);
  scarabQueue.push(...commands);
};
